import { TableColumnVisibilityController, TableColumnGroup } from "../../../../shared/scripts/table-column-visibility";
import { SiteReport } from "./sites-tracker.entities";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { GetSelectedDropdownValues, InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";
import { RenderDateMDY, RenderNullableNumberWithSeparators, RenderProgressBar, RenderNullabledNumberAndRound_2Digits, RenderNullableNumber } from "../../../../shared/scripts/table-functions";



export class SiteReportDataTable {

    SiteReportList: SiteReport[];
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;
    grouping: string;

    constructor(SiteReportList: SiteReport[], Grouping: string) {
        this.SiteReportList = SiteReportList;
        this.grouping = Grouping;


        this.initializeTable();

    }


    initializeTable(): void {

        let columns: any[] = [
            { data: "SiteCode", title: "Site Code", className: "site-code text-left font-size12 nowrap", width: '110px' },
            { data: "SiteName", title: "Site Name", className: "site-name text-left font-size12 nowrap", width: '110px' },
            { data: "TrialName", title: "Trial Name", className: "trial-name text-left font-size12 nowrap", width: '110px' },
            { data: "PlatformName", title: "Platform Name", className: "trial-name text-left font-size12 nowrap", width: '110px' },
            { data: "TrialRandomizedCount", title: "Total Randomized", className: "budget text-center font-size12 nowrap", width: '110px' },
            { data: "DaysSinceLastRandomizationTrial", title: "Days Since<br>Last Randomization", className: "status text-center font-size12 nowrap", width: '110px', render: RenderNullableNumber },
            { data: "EnrollmentPerMonth", title: "Enrollment<br>Per Month", className: "rfa text-center font-size12 nowrap", width: '110px' },
            { data: "EnrolledLast30Days", title: "Enrollment<br>Last 30 Days", className: "pasa-study-aim text-center font-size12 nowrap", width: '110px' },
            { data: "DaysFromInitatedToExecuted", title: "Days From<br>Initiated To Executed", className: "pasa-research-category text-center font-size12 nowrap", width: '110px', render: RenderNullableNumber },
            { data: "DaysFromRegSentToRegComplete", title: "Days From<br>Regulatory Pack Sent To Complete", className: "trl text-center font-size12 nowrap", width: '110px', render: RenderNullableNumber },
            { data: "DaysFromActivationToRandomization", title: "Days From<br>Activation To Randomization", className: "study-description text-center font-size12 nowrap", width: '300px', render: RenderNullableNumber },
            { data: "PercentPartialStudyInverventionCompleters", title: "% Partial Study<br>Intervention Completers", className: "product-target text-center font-size12 nowrap", width: '110px' },
            { data: "PercentDiscontinuedIntervention", title: "% Discontinued<br>Intervention", className: "treatment-type text-center font-size12 nowrap", width: '300px' },
            { data: "PercentDiscontinuedStudy", title: "% Discontinued<br>Study Follow-Up", className: "ptsd-or-tbi text-center font-size12 nowrap", width: '110px' },
            { data: "PercentHispanic", title: "% Hispanic", className: "study-population text-center font-size12 nowrap", width: '300px' },
            { data: "PercentNonWhite", title: "% Non-White", className: "ind text-center font-size12 nowrap", width: '300px' },
            { data: "PercentHispanicOrNonWhite", title: "% Hispanic<br>Or Non-White", className: "industry-partner text-center font-size12 nowrap", width: '300px' },
            { data: "PercentFemale", title: "% Female", className: "study-sites text-center font-size12 nowrap", width: '110px' },
            { data: "PercentVisitsNotDone", title: "% Visits<br>Not Done", className: "notes-comments text-center font-size12 nowrap", width: '110px' },
            { data: "PercentVisitsCompletedOutOfWindow", title: "% Visits Completed<br>Outside Of Window", className: "publications text-center font-size12 nowrap", width: '110px' },
            { data: "PercentNotEvaluable", title: "% Not<br>Evaluable", className: "publications text-center font-size12 nowrap", width: '110px' },
/*            { data: "MonthsSinceActivation", title: "Months SInce Activation", className: "publications text-left font-size12 nowrap", width: '110px' },*/

        ];

        this.dataTable = $('#' + this.grouping+'-report-table').DataTable({
            //"dom": '<"top-controls"<"' + this.grouping + '-column-select"><"' + this.grouping + '-search-bar"f><"spacer"><"' + this.grouping + '-count-found"B>>rtip',
            "dom": '<"top-controls"<"spacer"><"' + this.grouping + '-count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                }
            ],
            createdRow: (row, data: any, index) => {
                //cell formatting on percentages
                this.setCellPercentValue(row, 'td:eq(11)', this.getCellColorByValue("Completed", parseInt(data.PercentPartialStudyInverventionCompleters.slice(0,-1))), 100);
                this.setCellPercentValue(row, 'td:eq(12)', this.getCellColorByValue("Completed", parseInt(data.PercentDiscontinuedIntervention.slice(0, -1))), 100);
                this.setCellPercentValue(row, 'td:eq(13)', this.getCellColorByValue("Completed", parseInt(data.PercentDiscontinuedStudy.slice(0, -1))), 100);
                this.setCellPercentValue(row, 'td:eq(14)', this.getCellColorByValue("Completed", parseInt(data.PercentHispanic.slice(0, -1))), 100);
                this.setCellPercentValue(row, 'td:eq(15)', this.getCellColorByValue("Completed", parseInt(data.PercentNonWhite.slice(0, -1))), 100);
                this.setCellPercentValue(row, 'td:eq(16)', this.getCellColorByValue("Completed", parseInt(data.PercentHispanicOrNonWhite.slice(0, -1))), 100);
                this.setCellPercentValue(row, 'td:eq(17)', this.getCellColorByValue("Completed", parseInt(data.PercentFemale.slice(0, -1))), 100);
                this.setCellPercentValue(row, 'td:eq(18)', this.getCellColorByValue("Completed", parseInt(data.PercentVisitsNotDone.slice(0, -1))), 100);
                this.setCellPercentValue(row, 'td:eq(19)', this.getCellColorByValue("Completed", parseInt(data.PercentVisitsCompletedOutOfWindow.slice(0, -1))), 100);
                this.setCellPercentValue(row, 'td:eq(20)', this.getCellColorByValue("Completed", parseInt(data.PercentNotEvaluable.slice(0, -1))), 100);
                //if (data.Overdue[1] != undefined) { this.setCellPercentValue(row, 'td:eq(7)', this.getCellColorByValue("Overdue", data.Overdue[1]), data.Overdue[0]); }
                //if (data.NotDone[1] != undefined) { this.setCellPercentValue(row, 'td:eq(8)', this.getCellColorByValue("NotDone", data.NotDone[1]), data.NotDone[0]); }
                //if (data.DiscPrior[1] != undefined) { this.setCellPercentValue(row, 'td:eq(9)', this.getCellColorByValue("DiscPrior", data.DiscPrior[1]), data.DiscPrior[0]); }

                //tooltip config for percentages and site number
                //$(row).attr('title', data.Site);
                //$(row).find('td').each(function (index, td) {
                //    $(td).attr('data-toggle', 'tooltip');
                //    $(td).attr('data-placement', 'top');
                //});
            },
            order: [[1, 'asc']],
            data: this.SiteReportList
        });

        $(".top-controls").addClass('row mx-0');

        //$("." + this.grouping + "-column-select").addClass('col-12 col-md-3 px-0');
        //$("." + this.grouping + "-column-select").empty().html('<div id="' + this.grouping + '-column-select"></div>');

        //$("." + this.grouping + "-search-bar").addClass('col-12 col-md-3');

        $(".spacer").addClass('col-12 col-md-3');
        $("." + this.grouping + "-count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        $("." + this.grouping + "-count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"tasks-found-count-'+this.grouping+'\"></span></div>');
        $("." + this.grouping + "-count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        //this.tableColumnController = new TableColumnVisibilityController(this.grouping + '-report-table', this.grouping + '-column-select', [
        //    new TableColumnGroup("Site Code", true, [], "site-code"),
        //    new TableColumnGroup("Site Name", true, [], "site-name"),
        //    //new TableColumnGroup("Title", true, [], "title-full"),
        //    //new TableColumnGroup("PI Last Name", true, [], "pi-last-name"),
        //    //new TableColumnGroup("POP Date", true, [], "pop-date"),
        //    //new TableColumnGroup("Budget $K", true, [], "budget"),
        //    //new TableColumnGroup("Status", true, [], "status"),
        //    //new TableColumnGroup("RFA", true, [], "rfa"),
        //    //new TableColumnGroup("PASA Study Aim", true, [], "pasa-study-aim"),
        //    //new TableColumnGroup("PASA Research Category", true, [], "pasa-research-category"),
        //    //new TableColumnGroup("TRL", true, [], "trl"),
        //    //new TableColumnGroup("Study Description", true, [], "study-description"),
        //    //new TableColumnGroup("Product Target", true, [], "product-target"),
        //    //new TableColumnGroup("Treatment Type", true, [], "treatment-type"),
        //    //new TableColumnGroup("PTSD or TBI related", true, [], "ptsd-or-tbi"),
        //    //new TableColumnGroup("Study Population", true, [], "study-population"),
        //    //new TableColumnGroup("IND/Patent#", true, [], "ind"),
        //    //new TableColumnGroup("Industry Partner/Translation", true, [], "industry-partner"),
        //    //new TableColumnGroup("Study Sites", true, [], "study-sites"),
        //    //new TableColumnGroup("Notes/Comments", true, [], "notes-comments"),
        //    //new TableColumnGroup("Publications", true, [], "publications"),
        //    //new TableColumnGroup("Presentations", true, [], "presentations"),


        //]);

        $('#' + this.grouping + '-report-table').on('search.dt', (e, settings) => {
            this.setCountFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });
        this.setCountFoundLabel(this.SiteReportList.length);
    }

    setCountFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#tasks-found-count-' + this.grouping).text("No Studies Found"); break;
            case 1: $('#tasks-found-count-' + this.grouping).text("1 Study Found"); break;
            default: $('#tasks-found-count-' + this.grouping).text(count + " Studies Found");
        }
    }

    refresh(): void {
        this.dataTable.columns.adjust();
        //this.tableColumnController.refresh();
    }

    private setCellPercentValue(row: any, cell: string, color: string, count: number): void {
        $(cell, row).css('background-color', color);
        $(cell, row).attr('title', 'n = ' + count);
        $(cell, row).attr('data-toggle', 'tooltip');
        $(cell, row).attr('data-placement', 'top');
    }

    private getCellColorByValue(dataElement: string, value: number): string {
        if (dataElement == "Completed") {
            if (value >= 50) return "#7fb87f";
            else if (value >= 11) return "#FCE77D";
            else return "#F07D7D";
        }
        else if (dataElement == "Overdue" || dataElement == "NotDone") {
            if (value < 0.15) return "#7fb87f";
            else if (value <= 0.35) return "#FCE77D";
            else return "#F07D7D";
        }
        else if (dataElement == "DiscPrior") {
            if (value < 0.05) return "#7fb87f";
            else if (value <= 0.10) return "#FCE77D";
            else return "#F07D7D";
        }
    }

}